import React from 'react';
import {Redirect, Link} from "react-router-dom";
import {queryApiGet} from '../api.js'
import ErrorComponent from "./error";

class GoToSiteStatus extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            siteStatus: null,
            errorMessages: [],
            redirectPath: null
        }
    }

    componentDidMount() {
        this.loadSiteStatus()
    }

    loadSiteStatus() {
        const pathParts = window.location.pathname.split('/');
        const siteId = pathParts[pathParts.length - 1];
        
        queryApiGet(
            `/api/siteStatus?siteId=${siteId}`
        ).then(data => {
            console.log('Site status data:', data);
            this.setState({
                loading: false,
                siteStatus: data
            })
        }).catch((e) => {
            this.handleError(e, siteId);
        })
    }

    handleError(error, siteId) {
        if (error.errorCode === 'AB_running') {
            // Load AB info and redirect to updateAb
            this.loadAbInfo(siteId);
        } else {
            this.setErrorState(error);
        }
    }

    loadAbInfo(siteId) {
        queryApiGet(
            `/api/abInfo?siteId=${siteId}`
        ).then(data => {
            console.log('AB info data:', data);
            const demoId = data.abInfo.id;
            this.setState({
                redirectPath: `/updateAb/${siteId}/${demoId}`
            });
        }).catch((e) => this.setErrorState(e))
    }

    setErrorState(errorMessage) {
        this.setState({
            loading: false,
            errorMessages: [...this.state.errorMessages || [], errorMessage.message || String(errorMessage)]
        })
    }

    getErrorComponent() {
        return <ErrorComponent errorMessages={this.state.errorMessages}></ErrorComponent>
    }

    render() {
        if (this.state.redirectPath) {
            return <Redirect to={this.state.redirectPath} />
        }

        if (this.state.errorMessages?.length) {
            return this.getErrorComponent();
        }

        if (this.state.loading) {
            return (
                <div style={{textAlign: "center", padding: "20px"}}>
                    Loading site status. Please wait...
                </div>
            )
        }

        if (this.state.siteStatus) {
            const status = this.state.siteStatus;
            return (
                <div style={{padding: "20px", maxWidth: "1000px", margin: "0 auto"}}>
                    <h2>Site Status: {status.siteId}</h2>
                    
                    <div style={{marginBottom: "20px"}}>
                        <table border={1} width={'100%'} style={{fontSize: 14, borderCollapse: 'collapse'}}>
                            <thead>
                                <tr style={{backgroundColor: "#333", color: "white"}}>
                                    <td style={{padding: "8px", fontWeight: "bold"}}>Site ID</td>
                                    <td style={{padding: "8px", fontWeight: "bold"}}>Type</td>
                                    <td style={{padding: "8px", fontWeight: "bold"}}>Logic</td>
                                    <td style={{padding: "8px", fontWeight: "bold"}}>Logic Hash</td>
                                    <td style={{padding: "8px", fontWeight: "bold"}}>Settings</td>
                                    <td style={{padding: "8px", fontWeight: "bold"}}>Settings Hash</td>
                                    <td style={{padding: "8px", fontWeight: "bold"}}>Last Modified</td>
                                    <td style={{padding: "8px", fontWeight: "bold"}}>Controls</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{padding: "8px"}}>{status.siteId}</td>
                                    <td style={{padding: "8px"}}>{status.type}</td>
                                    <td style={{padding: "8px"}}>{status.version.logic.commitish}</td>
                                    <td style={{padding: "8px", fontFamily: "monospace", fontSize: "12px"}}>
                                        {status.version.logic.hash.substring(0, 6)}
                                    </td>
                                    <td style={{padding: "8px"}}>{status.version.settings.commitish}</td>
                                    <td style={{padding: "8px", fontFamily: "monospace", fontSize: "12px"}}>
                                        {status.version.settings.hash.substring(0, 6)}
                                    </td>
                                    <td style={{padding: "8px"}}>{status.lastModified}</td>
                                    <td style={{padding: "8px", textAlign: 'left'}}>
                                        <ul style={{margin: 0}}>
                                            <li>
                                                <Link 
                                                    to={`/updateSettings/${status.siteId}`}
                                                    style={{color: '#ffff99'}}
                                                >
                                                    Update Settings
                                                </Link>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <button 
                            onClick={() => window.history.back()}
                            style={{
                                padding: "10px 20px",
                                backgroundColor: "#007bff",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer"
                            }}
                        >
                            Back
                        </button>
                    </div>
                </div>
            );
        }

        return <div>No data</div>;
    }
}

export default GoToSiteStatus;
